module.exports = __webpack_public_path__ + "static/media/step-2.02ea7673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/how-it-works/stepper-how-it-works/step-2.png
// module id = 2211
// module chunks = 0